export default __webpack_public_path__ + "static/media/file-text-circle-white-tc.5e572a87.svg";